module.exports = __webpack_public_path__ + "cloud-region.ebceb92efe808c486f390440df97e0e9.hashedasset.svg";